


































































































































































































































































































































import {Component, Vue, Watch, Provide} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import ComplaintState from '@/store/modules/complaint/types';
import FilesUploader from '@/views/Manager/Complaints/FilesUploader.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';

@Component({
    components: { FilesUploader, DatePicker },
})
export default class SingleComplaint extends Vue {

    @Action public updateComplaint: any;
    @Action public setSureModal: any;

    @State('complaint') public complaintState: ComplaintState;

    @Provide() public $bvModal: any;

    @Provide() public isDisabled = true;
    @Provide() public isDisabledSave = true;

    @Provide() public validation = {
        account_number: '', invoice_number: '', articles: '',
        region: '', district: '', city: '', street: '', house: '',  structure: '', building: '', description: '',
        installation_date: '', bad_date: '', conditions: '', wishes: '',
    };

    @Provide() public isChanged = false;

    @Provide() public lang = {
        formatLocale: {
            firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
    };

    @Watch('complaintState.complaint', {immediate: true, deep: true})
    public async complaintWatch() {

        this.isChanged = true;

        this.validation = {
            account_number: '', invoice_number: '', articles: '',
            region: '', district: '', city: '', street: '', house: '', structure: '', building: '', description: '',
            installation_date: '', bad_date: '', conditions: '', wishes: '',
        };
        this.isDisabled = false;
        this.isDisabledSave = false;

        if (this.complaintState.complaint.account_number.toString() === '' &&
            this.complaintState.complaint.invoice_number.toString() === '') {
            if (this.complaintState.complaint.account_number.toString() === '') {
                this.validation.account_number = 'Необходимо заполнить Номер счёта поставки оборудования';
            }
            if (this.complaintState.complaint.invoice_number.toString() === '') {
                this.validation.invoice_number = 'Необходимо заполнить Номер накладной поставки оборудования';
            }
            this.isDisabled = true;
        }

        if (this.complaintState.complaint.account_number &&
            this.complaintState.complaint.account_number.toString() !== '' &&
            this.complaintState.complaint.account_number.length > 11) {
            this.validation.account_number = 'Номер счёта поставки оборудования не может быть длиннее 11 символов';
            this.isDisabled = true;
        }

        if (this.complaintState.complaint.invoice_number &&
            this.complaintState.complaint.invoice_number.toString() !== '' &&
            this.complaintState.complaint.invoice_number.length > 40) {
            this.validation.invoice_number = 'Номер накладной поставки оборудования не может быть длиннее 40 символов';
            this.isDisabled = true;
        }

        const articles = this.complaintState.complaint.articles.filter((a) => (a.article_number !== '' && a.quantity !== '' && a.isDeleted !== true));
        if (articles.length <= 0) {
            this.validation.articles = 'Необходимо полностью заполнить хотя бы одну строку с артикулом и количеством ед. оборудования';
            this.isDisabled = true;
        }

        // Если нет ни одной заполненой строки
        if (this.complaintState.complaint.articles.filter((a) =>
            (a.article_number !== '' && parseInt(a.quantity, 10) > 0 && a.isDeleted !== true)).length <= 0) {
            this.isDisabled = true;
        }

        // Если есть строки, где либо артикул превышает 40 символов, либо количество больше 2147483647
        if (this.complaintState.complaint.articles.filter((a) =>
            (a.article_number.length > 40 || a.quantity.length > 11)).length > 0) {
            this.isDisabled = true;
        }

        // Если не указан регион, район или город
        if ((!this.complaintState.complaint.region || this.complaintState.complaint.region === '') &&
            (!this.complaintState.complaint.district || this.complaintState.complaint.district === '') &&
            (!this.complaintState.complaint.city || this.complaintState.complaint.city === '')) {
            if (!this.complaintState.complaint.region || this.complaintState.complaint.region === '') {
                this.validation.region = 'Необходимо указать республику, край, округ, область';
            }
            if (!this.complaintState.complaint.district || this.complaintState.complaint.district === '') {
                this.validation.district = 'Необходимо указать район';
            }
            if (!this.complaintState.complaint.city || this.complaintState.complaint.city === '') {
                this.validation.city = 'Необходимо указать город';
            }
            this.isDisabled = true;
        }

        // Если не указан номер дома или строение
        if ((!this.complaintState.complaint.house || this.complaintState.complaint.house === '')) {
            if (!this.complaintState.complaint.house || this.complaintState.complaint.house === '') {
                this.validation.house = 'Необходимо указать дом';
            }
            this.isDisabled = true;
        }

        // Описание
        if (!this.complaintState.complaint.description || this.complaintState.complaint.description === '') {
            this.validation.description = 'Необходимо указать причину обращения';
            this.isDisabled = true;
        }

        // Длина сообщения
        if (this.complaintState.complaint.description && this.complaintState.complaint.description.length > 250) {
            this.validation.description = 'Длина текста не должна превышать 250 символов';
            this.isDisabled = true;
        }

        // Дата установки оборудования
        if (!this.complaintState.complaint.installation_date || this.complaintState.complaint.installation_date === '') {
            this.validation.installation_date = 'Необходимо указать дату установки оборудования';
            this.isDisabled = true;
        }

        // Дата возникновения неисправности
        if (!this.complaintState.complaint.bad_date || this.complaintState.complaint.bad_date === '') {
            this.validation.bad_date = 'Необходимо указать дату возникновения неисправности';
            this.isDisabled = true;
        }

        // Условия возникновения неисправности
        if (!this.complaintState.complaint.conditions || this.complaintState.complaint.conditions === '') {
            this.validation.conditions = 'Необходимо указать условия возникновения неисправности';
            this.isDisabled = true;
        } else if (this.complaintState.complaint.conditions.length > 250) {
            this.validation.conditions = 'Длина текста не должна превышать 250 символов';
            this.isDisabled = true;
        }

        // Пожелания
        if (!this.complaintState.complaint.wishes || this.complaintState.complaint.wishes === '') {
            this.validation.wishes = 'Необходимо указать пожелания';
            this.isDisabled = true;
        } else if (this.complaintState.complaint.wishes.length > 250) {
            this.validation.wishes = 'Длина текста не должна превышать 250 символов';
            this.isDisabled = true;
        }

        // Длины полей с адресами
        if (this.complaintState.complaint.region && this.complaintState.complaint.region.length > 50) {
            this.validation.region = 'Длина поля не должна превышать 50 символов';
            this.isDisabled = true;
        }
        if (this.complaintState.complaint.district && this.complaintState.complaint.district.length > 50) {
            this.validation.district = 'Длина поля не должна превышать 50 символов';
            this.isDisabled = true;
        }
        if (this.complaintState.complaint.city && this.complaintState.complaint.city.length > 50) {
            this.validation.city = 'Длина поля не должна превышать 50 символов';
            this.isDisabled = true;
        }
        if (this.complaintState.complaint.street && this.complaintState.complaint.street.length > 50) {
            this.validation.street = 'Длина поля не должна превышать 50 символов';
            this.isDisabled = true;
        }

        if (this.complaintState.complaint.house && this.complaintState.complaint.house.length > 5) {
            this.validation.house = 'Длина поля не должна превышать 5 символов';
            this.isDisabled = true;
        }
        if (this.complaintState.complaint.structure && this.complaintState.complaint.structure.length > 5) {
            this.validation.structure = 'Длина поля не должна превышать 5 символов';
            this.isDisabled = true;
        }
        if (this.complaintState.complaint.building && this.complaintState.complaint.building.length > 5) {
            this.validation.building = 'Длина поля не должна превышать 5 символов';
            this.isDisabled = true;
        }
    }

    @Watch('complaintState.complaint.articles', {immediate: true, deep: true})
    public async articlesWatch() {
        // if (this.complaintState.complaint.registration_number) {
        //     return;
        // }
        if (this.complaintState.complaint.articles.length === 0) {
            this.addArticleRow();
        }
        // else {
        //     const lastArticle = this.complaintState.complaint.articles[this.complaintState.complaint.articles.length - 1];
        //     if (lastArticle.article_number !== '' || lastArticle.quantity !== '') {
        //         this.addArticleRow();
        //     }
        // }
    }

    public update() {
        this.updateComplaint();
        this.close();
    }

    public send() {
        this.setSureModal({
            title: 'Отправить заявку на рассмотрение?',
            text: `Вы уверены, что хотите отправить заявку на рассмотрение? Редактировать заявку после отправки будет невозможно!`,
            buttonOk: 'Отправить заявку на рассмотрение',
            action: async () => {
                this.complaintState.complaint.status = 'public';
                this.updateComplaint();
                this.close();
            },
        });
    }

    public close() {
        this.$bvModal.hide('singleComplaintModal');
    }

    /* Работа с таблице артикулов */

    public addArticleRow() {
        if (this.complaintState.complaint.status !== 'draft') {
            return;
        }
        this.complaintState.complaint.articles.push({
            article_number: '',
            quantity: '',
        });
    }

    public deleteArticle(i) {
        const article = Object.assign({}, this.complaintState.complaint.articles[i], {isDeleted: true});
        this.complaintState.complaint.articles.splice(i, 1, article);
    }

    public restoreArticle(i) {
        const article = Object.assign({}, this.complaintState.complaint.articles[i], {isDeleted: false});
        this.complaintState.complaint.articles.splice(i, 1, article);
    }

    /* Форматирование даты */

    private get resolvedInstallationDate() {
        return this.complaintState.complaint.installation_date !== undefined ?
            new Date(this.complaintState.complaint.installation_date) : new Date(Date.now());
    }

    private set resolvedInstallationDate(date) {
        this.complaintState.complaint.installation_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

    private get resolvedBadDate() {
        return this.complaintState.complaint.bad_date !== undefined ?
            new Date(this.complaintState.complaint.bad_date) : new Date(Date.now());
    }

    private set resolvedBadDate(date) {
        this.complaintState.complaint.bad_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

}
